import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';

const CuadrosDashboardDefault = Loadable(lazy(() => import('pages_cuadros/dashboard/default')));
const CuadrosGestionObras = Loadable(lazy(() => import('pages_cuadros/gestion-obras')));
const CuadrosObraInfo = Loadable(lazy(() => import('pages_cuadros/obras-info')));

const CuadrosRoutes = {
  path: '/cuadros',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    { path: '', element: <Navigate to="/cuadros/dashboard/default" replace /> },
    {
      path: 'dashboard',
      children: [
        { path: 'default', element: <CuadrosDashboardDefault /> },
        { path: 'gestion-obras', element: <CuadrosGestionObras /> }
      ]
    },
    { path: 'obras/:obraId', element: <CuadrosObraInfo /> }
  ]
};

export default CuadrosRoutes;
